/**
 * © 2025 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * --- REWRITE (V3 - Definitive Linting Fix) ---
 * - MISSION: To fix the final `react-refresh/only-export-components`
 * warning by importing the context from a separate file.
 *
 * - ARCHITECTURE:
 * 1.  This file now imports `LoadingContext` from the new, dedicated
 * `loading.context.js` file.
 * 2.  This file's ONLY export is now the `LoadingProvider` component.
 *
 * - RESULT: This change fully resolves the last linting warning.
 */
import { useState } from 'react';
import { LoadingContext } from './loading.context.js';

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const value = { isLoading, setIsLoading };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};
